// import React from 'react';
// import PropTypes from 'prop-types';
// import { Route, Redirect } from 'react-router-dom';

// const PrivateRoute = ({ component: Component, isAuthenticated, ...rest }) => (
//     <Route
//       {...rest}
//       render={(props) => (isAuthenticated ? <Component {...props} /> : <Redirect to={{ pathname: '/login', state: { from: props.location } }}/>)
//       }
//     />
// );

// PrivateRoute.propTypes = {
//   component: PropTypes.func.isRequired,
//   isAuthenticated: PropTypes.bool.isRequired,
//   location: PropTypes.object,
// };

// export default PrivateRoute;

import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, withRouter } from 'react-router-dom';
// import Reload from '../Reload';

const PrivateRoute = ({ children, auth, ...rest }) => {
  // const token = localStorage.getItem('cr_token');
  switch (true) {
    // case ((token) && (!auth)):
    //   return (
    //     <Route {...rest} render={(props) => <Reload {...props} token={token}/> } />
    //   );
    case (auth):
      return (
        <Route {...rest} render={(props) => children } />
      );
    default:
      return (
        <Route {...rest} render={(props) => (<Redirect to={{ pathname: '/login', state: { from: props.location } }}/>) } />
      );
  }
};

PrivateRoute.propTypes = {
  children: PropTypes.object.isRequired,
  auth: PropTypes.bool.isRequired,
  location: PropTypes.object,
};

export default withRouter(PrivateRoute);
